import Vue from "vue";
import VueRouter from "vue-router";
import RouterGuard from "./router-guard";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    beforeEnter: RouterGuard.requireLogged,
    redirect: { name: "Autopricing" }
  },
  {
    path: "/autopricing",
    name: "Autopricing",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/Autopricing")
  },
  {
    path: "/autopricing-admin",
    name: "AutopricingAdmin",
    beforeEnter: RouterGuard.isEditor,
    component: () => import("@/views/AutopricingAdmin")
  },
  {
    path: "/provider-configuration",
    name: "ProviderConfiguration",
    beforeEnter: RouterGuard.isEditor,
    component: () => import("@/views/ProviderConfiguration")
  },
  {
    path: "/users",
    name: "Users management",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/Users")
  },
  {
    path: "/safeguard/:license",
    name: "Safeguard",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/Safeguarding")
  },
  {
    path: "/safeguard-v2/:license",
    name: "SafeguardV2",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/SafeguardingV2")
  },
  {
    path: "/fees",
    name: "Fees",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/Fees")
  },
  {
    path: "/payin-fees",
    name: "PayinFees",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/PayinFees")
  },
  {
    path: "/analyzer",
    name: "Analyzer",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/Analyzer")
  },
  {
    path: "/provider-rates",
    name: "ProviderRates",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/ProviderRates")
  },
  {
    path: "/audit-log-rates",
    name: "AuditLogRates",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/AuditLogRates")
  },
  {
    path: "/audit-log-fees",
    name: "AuditLogFees",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/AuditLogFees")
  },
  {
    path: "/audit-log-payout",
    name: "AuditLogPayout",
    beforeEnter: RouterGuard.requireLogged,
    component: () => import("@/views/AuditLogPayout")
  },
  {
    path: "*",
    name: "not-found",
    beforeEnter: RouterGuard.redirectFromNotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
